const messages = {
  title: "Informacije o proizvodu i odobrenja",
  description:
    "Dobrodošli u sekciju brošura i cjenovnika oko proizvoda Bridgestone i Firestone. Ovdje možete pronaći aktuelne brošure i cjenovnike za sve proizvodne oblasti i Pricat fajlove za vaše upravljanje zalihama.",
};
export default {
  messages,
};
